export const useUserPermissions = () => {
  const lsReadOnlyAccess = localStorage.getItem("r");
  const lsRoasCampaignsEnabled = localStorage.getItem("rc");
  const canViewEvents = lsReadOnlyAccess ? lsReadOnlyAccess !== "1" : true;
  const s = localStorage.getItem("s");
  const isSpecialMode = s === "1" || s === "2";
  const isMain = s === "1";
  const isRoasCampaignsEnabled = lsRoasCampaignsEnabled === "1";
  const isBiddingTypeEnabled = localStorage.getItem("b") === "1";
  const isNotificationManagerEnabled = localStorage.getItem("nm") === "1";

  return {
    canViewEvents,
    isSpecialMode,
    isMain,
    isRoasCampaignsEnabled,
    isBiddingTypeEnabled,
    isNotificationManagerEnabled,
  };
};
